var map = {
	"./areas": "AlAi",
	"./areas.vue": "AlAi",
	"./contacts": "CMSj",
	"./contacts.vue": "CMSj",
	"./home": "gHLv",
	"./home.vue": "gHLv",
	"./network": "2ZHj",
	"./network.vue": "2ZHj",
	"./numbers": "9/Up",
	"./numbers.vue": "9/Up",
	"./projects": "NsqJ",
	"./projects.vue": "NsqJ",
	"./services": "TiHX",
	"./services.vue": "TiHX",
	"./technology": "NKZn",
	"./technology.vue": "NKZn"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5/oC";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages ^\.\/.*$
// module id = 5/oC
// module chunks = 1